import { ReferenceArrayInput as RAReferenceArrayInput, ReferenceArrayInputProps } from 'react-admin';

/**
 * Custom ReferenceArrayInput that automatically uses /references endpoint
 * 
 * This component wraps React Admin's ReferenceArrayInput and automatically
 * adds meta.useReferenceEndpoint flag so the dataProvider uses the /references endpoint.
 * 
 * Reference endpoints are lighter, return minimal data, and use smart permission checking.
 * 
 * @example
 * <ReferenceArrayInput source="roleIds" reference="role">
 *   <AutocompleteArrayInput optionText="name" />
 * </ReferenceArrayInput>
 */
export const ReferenceArrayInput = (props: ReferenceArrayInputProps) => {
    return (
        <RAReferenceArrayInput
            {...props}
            queryOptions={{
                ...(props.queryOptions || {}),
                meta: {
                    ...(props.queryOptions?.meta || {}),
                    useReferenceEndpoint: true,
                },
            }}
        />
    );
};

